import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { OptionComponent } from './select-option/select-option.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [SelectComponent, OptionComponent],
  imports: [CommonModule, InputModule, CheckboxModule, TooltipModule],
  exports: [SelectComponent, OptionComponent],
})
export class SelectModule {}
